import { format } from 'date-fns';
/**
 * Returns a 'business date' string for a given date.
 */
export const getBusinessDateString = (date) => {
    return format(date, 'yyyy-MM-dd');
};
